import React, { Component } from 'react';
import Img from 'gatsby-image';
import classNames from 'classnames';
import styles from './Image.module.less';
import loader from '../../images/loader.svg';

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  handleLoad = () => {
    this.setState({
      isLoading: false,
    });
  }


  render() {
    return (
      <div className={classNames(styles.container, this.props.containerClassName)}>
        <div className={classNames(styles.loaderBG, { [styles.active]: this.state.isLoading })}>
          <img className={styles.loaderIcon} src={loader} />
        </div>
        <Img onLoad={() => this.handleLoad()} className={this.props.className} sizes={this.props.sizesThumbnail} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/Image.jsx